var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.138,
    height: 10.621,
    viewBox: "0 0 21.138 10.621",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "right-arrow_3_",
    "data-name": "right-arrow (3)",
    transform: "translate(21.138 137.99) rotate(180)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6899",
    "data-name": "Group 6899",
    transform: "translate(0 127.369)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29758",
    "data-name": "Path 29758",
    d: "M21,132.341h0l-4.8-4.8a.48.48,0,1,0-.677.677L19.5,132.2H.48a.48.48,0,0,0,0,.961H19.5l-3.982,3.982a.48.48,0,1,0,.677.677l4.8-4.8A.48.48,0,0,0,21,132.341Z",
    transform: "translate(0 -127.369)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrow);
export default __webpack_public_path__ + "static/media/right-arrow.740826287000acb892fc840ad9a4ea76.svg";
export { ForwardRef as ReactComponent };